import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling down 600px
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <AnimatePresence data-id="element-246">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-brand-dark/95 backdrop-blur-md border-t border-brand-border shadow-[0_-10px_40px_rgba(0,0,0,0.5)]" data-id="element-247">
          <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-248">
            <div className="hidden sm:block" data-id="element-249">
              <p className="text-white font-serif font-bold text-lg" data-id="element-250">
                Operación Suegra™
              </p>
              <p className="text-brand-gold text-sm" data-id="element-251">
                Oferta especial termina pronto
              </p>
            </div>
            <button onClick={scrollToPricing} className="w-full sm:w-auto bg-brand-red hover:bg-brand-redDark text-white font-bold py-3 px-8 rounded-lg shadow-[0_0_20px_rgba(192,57,43,0.4)] transition-all flex items-center justify-center gap-2 group" data-id="element-252">
              <ShoppingCart className="w-5 h-5 group-hover:scale-110 transition-transform" data-id="element-253" />
              <span data-id="element-254">QUIERO MI COPIA AHORA</span>
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}